import React, {createContext} from 'react';
const OrganisationContext = createContext(null);
export {OrganisationContext};